import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';

import CollapsableMenuItem from 'secured/components/layout/menu/CollapsableMenuItem';
import { Form } from 'common/components';
import classnames from 'classnames';
import ActiveLink from 'secured/components/layout/menu/ActiveLink';

import { createRoute } from 'lib/util';
import * as Menu from 'secured/components/layout/menu';

class SideMenu extends PureComponent {
  static propTypes = {
    menu: PropTypes.object,
    company: PropTypes.object.isRequired,
    permissions: PropTypes.object,
    subcompany: PropTypes.object,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    t: PropTypes.func.isRequired,
    toggleMenu: PropTypes.func,
    isMobile: PropTypes.bool,
  };

  render = () => (
    <div
      className={classnames('menu', { 'ml-2': !this.props.isMobile, 'mt-3': !this.props.isMobile })}
    >
      <ul className="menu-list py-0 my-0">
        <li className="bbottom py-1">
          <Form.Link
            pathname={this.props.location.pathname}
            to={`/companies/${this.props.company.id}`}
          >
            <i className="fa fa-home fa-lg" />
            <b>{this.props.company.shortname}</b>
          </Form.Link>
        </li>
        {this.props.subcompany && (
          <li>
            <ActiveLink
              pathname={this.props.location.pathname}
              to={createRoute(this.props.company.id, this.props.subcompany.id, 'dashboard')}
            >
              <i className="fa fa-bar-chart fa-lg" />
              {this.props.t('menu.dashboard')}
            </ActiveLink>
          </li>
        )}
        {this.props.subcompany && this.props.permissions['acl.assets.get'] && (
          <li>
            <ActiveLink
              pathname={this.props.location.pathname}
              to={createRoute(this.props.company.id, this.props.subcompany.id, 'assets')}
            >
              <i className="fa fa-qrcode fa-lg" />
              {this.props.t('menu.assets')}
            </ActiveLink>
          </li>
        )}

        {this.props.subcompany && this.props.permissions['acl.notification_historic.get'] && (
          <li>
            <ActiveLink
              pathname={this.props.location.pathname}
              to={createRoute(
                this.props.company.id,
                this.props.subcompany.id,
                'notifications_historic'
              )}
            >
              <i className="fa fa-bell fa-lg" />
              {this.props.t('menu.notifications_historic')}
            </ActiveLink>
          </li>
        )}

        {/* Mantenimiento */}
        {/* {this.props.subcompany &&
          this.props.permissions["acl.mantenimiento.get"] && (
            <li>
              <ActiveLink
                pathname={this.props.location.pathname}
                to={createRoute(this.props.company.id, this.props.subcompany.id, "maintenance")}
              >
                <i className="fa fa-qrcode fa-lg" />
                {this.props.t("menu.maintenance")}
              </ActiveLink>
            </li>
          )} */}
        {/* Mantenimiento */}

        {this.props.subcompany && (
          <li>
            <ActiveLink
              pathname={this.props.location.pathname}
              to={createRoute(this.props.company.id, this.props.subcompany.id, 'import')}
            >
              <i className="fa fa-upload fa-lg" />
              {this.props.t('menu.import')}
            </ActiveLink>
          </li>
        )}

        {this.props.subcompany && (
          <Menu.Reports
            isCollapsed={this.props.menu.isCollapsedReports}
            company={this.props.company}
            subcompany={this.props.subcompany}
            permissions={this.props.permissions}
            toggleMenu={this.props.toggleMenu}
          />
        )}
        {this.props.subcompany && (
          <Menu.Configuration
            isCollapsed={this.props.menu.isCollapsedConfiguration}
            company={this.props.company}
            subcompany={this.props.subcompany}
            permissions={this.props.permissions}
            toggleMenu={this.props.toggleMenu}
          />
        )}
        {this.props.company && (
          <Menu.ControlPanel
            isCollapsed={this.props.menu.isCollapsedControlPanel}
            company={this.props.company}
            permissions={this.props.permissions}
            toggleMenu={this.props.toggleMenu}
          />
        )}
      </ul>
    </div>
  );
}

export default withRouter(translate()(SideMenu));



// WEBPACK FOOTER //
// src/modules/secured/components/layout/SideMenu.js